module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as0911-bd6e8db532d5c6809182ca1fc2bc7bf8.jpg";